import type { ApiRoute, NoPathParams, NoResponse } from "../../api"

export interface SetManualExteriorColorQueryParams {
	"inventory-id": string
}

export interface SetManualExteriorColorBody {
	hexCode: string
	name: Record<string, string>
	tagKey: string
	typeKey: string
}

export const setManualExteriorColorRoute: ApiRoute<
	NoPathParams,
	SetManualExteriorColorQueryParams,
	SetManualExteriorColorBody,
	NoResponse
> = {
	buildUrl: () => "/colors/exterior-color/manual",
	method: "post",
	path: "/colors/exterior-color/manual",
}
